'use client';
import { jsx } from 'react/jsx-runtime';

const MobileTakeover = ({ children, open, }) => {
    return (jsx("div", { className: `fixed inset-0 bg-leland-white ${open ? 'flex' : 'hidden'} px-6 pt-7`, children: children }));
};

export { MobileTakeover };
//# sourceMappingURL=mobile-takeover.js.map
